import { lazy } from 'react';
const routes = [
    {
        path: '/',
        component: lazy(() => import('./login')),
        isPrivate: false,
    },
    {
        path: '/verify',
        component: lazy(() => import('./verify')),
        isPrivate: false,
    },
    {
        path: '/congratulations',
        component: lazy(() => import('./congratulations')),
        isPrivate: false,
    },
    {
        path: '/change-password',
        component: lazy(() => import('./change-password')),
        isPrivate: true,
    },
    {
        path: '/products',
        component: lazy(() => import('./products')),
        isPrivate: true,
    },
];
export const PATHS = {
    LOGIN: '/',
    VERIFY: '/verify',
    CONGRATULATIONS: '/congratulations',
    CHANGE_PASSWORD: '/change-password',
    PRODUCTS: '/products',
};
export default routes;
